/* PostHog - zdarzenia interfejsu sklepu Solve Labs (Shopify), 08.10.2026. Init i kontekst: snippets/sl-posthog.liquid.
   Nazwy zdarzeń e-commerce wg specyfikacji PostHoga (jak w PrestaShopie, projekt 254890), reszta po polsku w props.
   Każdy klik/CTA/sekcja ma "miejsce" = nazwa sekcji motywu (albo data-place). Nigdy nie wysyłamy treści wpisywanej przez klienta
   (pola formularzy), tylko teksty interfejsu, identyfikatory i liczby. */
(function () {
  if (!window.SL_PH_ON) return;
  (window.SL_PH_READY = window.SL_PH_READY || []).push(run);
  function run() {
  var ctx = window.SL_PH_CTX || {}, cur = ctx.currency || 'PLN';
  function cap(n, p, o) { try { window.posthog.capture(n, p || {}, o); } catch (e) {} }
  function txt(el) { return ((el.getAttribute('aria-label') || el.innerText || el.value || el.title || '') + '').replace(/\s+/g, ' ').trim().slice(0, 60); }
  function miejsce(el) {
    if (!el || !el.closest) return ctx.page_type;
    var dp = el.closest('[data-place]'); if (dp) return dp.getAttribute('data-place');
    if (el.closest('.cart-drawer-modal')) return 'cart_drawer';
    var s = el.closest('[id^="shopify-section-"]'); if (!s) return 'poza_sekcja';
    var id = s.id.replace('shopify-section-', ''), m = id.split('__')[1] || id;
    return m.replace(/_[A-Za-z0-9]{6}$/, '');
  }
  function path(h) { try { var u = new URL(h, location.href); return u.host === location.host ? u.pathname : u.host + u.pathname; } catch (e) { return ''; } }
  var lastClick = { el: null, t: 0 };

  /* ---- widoki ---- */
  var P = ctx.product, C = ctx.collection, A = ctx.article;
  if (P) cap('Product Viewed', { product_id: String(P.product_id), variant_id: String(P.variant_id), sku: P.sku, name: P.name, category: P.category, brand: P.brand, variant: P.variant, price: P.price, currency: cur, url: location.pathname, available: P.available });
  if (C && ctx.page_type === 'collection') cap('Product List Viewed', { list_id: C.handle, category: C.name, count: C.count, page: C.page });
  if (A) cap('Article Viewed', { blog: A.blog, handle: A.handle, author: A.author, published: A.published });
  if (ctx.search) cap('Products Searched', { query: ctx.search.query, results: ctx.search.results });
  if (ctx.page_type === 'cart') cap('Cart Viewed', { miejsce: 'cart_page', value: ctx.cart_value, count: ctx.cart_count, currency: cur });
  if (ctx.page_type === '404') cap('Page Not Found', { path: location.pathname + location.search, referrer: document.referrer || null });

  /* ---- koszyk (fetch przechwycony w snippecie) ---- */
  var lastAdd = '';
  window.SL_PH_CART = function (url, body, j) {
    if (typeof body === 'string' && body.indexOf('"attributes"') !== -1 && body.indexOf('"updates"') === -1) return; // atrybuty koszyka (sl-click-ids), nie zmiana koszyka
    var place = Date.now() - lastClick.t < 5000 ? miejsce(lastClick.el) : ctx.page_type;
    if (/\/cart\/add/.test(url)) {
      var items = j && j.items ? j.items : [j];
      items.forEach(function (i) {
        if (!i || !i.variant_id) return;
        var key = i.variant_id + ':' + i.quantity + ':' + Math.floor(Date.now() / 1500);
        if (key === lastAdd) return; lastAdd = key;
        cap('Product Added', { product_id: String(i.product_id), variant_id: String(i.variant_id), sku: i.sku, name: i.product_title, variant: i.variant_title, price: (i.final_price || i.price) / 100, quantity: i.quantity, currency: cur, url: i.url, miejsce: place });
      });
      return;
    }
    var q = null, line = null;
    try { var b = typeof body === 'string' ? JSON.parse(body) : (body && body.get ? { quantity: body.get('quantity'), line: body.get('line'), id: body.get('id') } : body); q = b && b.quantity != null ? +b.quantity : null; line = b && (b.line || b.id); } catch (e) {}
    if (q === 0) cap('Product Removed', { line: String(line || ''), miejsce: place, cart_value: j && j.total_price != null ? j.total_price / 100 : null, currency: cur });
    else cap('Cart Updated', { quantity: q, miejsce: place, cart_value: j && j.total_price != null ? j.total_price / 100 : null, currency: cur });
  };

  /* ---- kliknięcia: CTA z miejscem, przejście do kasy ---- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('a, button, [role="button"], input[type="submit"], summary, label.swatch, .quick-add');
    if (!el) return;
    lastClick = { el: el, t: Date.now() };
    var m = miejsce(el), href = el.getAttribute('href');
    if (el.matches('[name="checkout"], a[href*="/checkout"]') || el.closest('.shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart')) {
      cap('Checkout Clicked', { miejsce: m, kanal: el.closest('.shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart') ? 'express' : 'koszyk', value: ctx.cart_value, currency: cur }, { transport: 'sendBeacon' });
      return;
    }
    cap('CTA Clicked', { miejsce: m, tekst: txt(el), typ: el.tagName === 'A' ? 'link' : 'przycisk', cel: href ? path(href) : null, page_type: ctx.page_type }, href ? { transport: 'sendBeacon' } : undefined);
  }, true);

  /* ---- wybór wariantu (wartość = nazwa wariantu z katalogu, nie treść klienta) ---- */
  document.addEventListener('change', function (e) {
    var el = e.target; if (!P || !el.closest || !el.closest('form[action*="/cart/add"], variant-picker, .variant-picker, [data-variant-picker]')) return;
    if (!/option|id/i.test(el.name || '') || el.type === 'number') return;
    var v = el.tagName === 'SELECT' ? (el.options[el.selectedIndex] || {}).text : el.value;
    cap('Variant Selected', { product_id: String(P.product_id), opcja: (el.name || '').replace(/^options\[|\]$/g, ''), wariant: (v || '').trim().slice(0, 60), miejsce: miejsce(el) });
  }, true);

  /* ---- szuflada koszyka ---- */
  var drawer = document.querySelector('.cart-drawer-modal'), lastOpen = 0;
  if (drawer && window.MutationObserver) new MutationObserver(function () {
    if (drawer.getAttribute('aria-hidden') === 'false' && Date.now() - lastOpen > 2000) { lastOpen = Date.now(); cap('Cart Viewed', { miejsce: 'cart_drawer', page_type: ctx.page_type, currency: cur }); }
  }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });

  /* ---- widoczność sekcji (ocena układu) i głębokość przewinięcia ---- */
  if (window.IntersectionObserver) {
    var secs = [].slice.call(document.querySelectorAll('main [id^="shopify-section-"], #MainContent [id^="shopify-section-"], [id^="shopify-section-template--"]'));
    var seen = {}, io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return; var s = en.target, m = miejsce(s); io.unobserve(s);
        if (seen[m]) return; seen[m] = 1;
        cap('Section Viewed', { miejsce: m, pozycja: secs.indexOf(s) + 1, sekcji: secs.length, page_type: ctx.page_type });
      });
    }, { threshold: 0.3 });
    secs.forEach(function (s) { if (s.offsetHeight > 40) io.observe(s); });
  }
  var marks = [25, 50, 75, 100], hit = {}, t0 = Date.now(), readSent = false;
  function onScroll() {
    var h = document.documentElement, max = h.scrollHeight - h.clientHeight; if (max < 200) return;
    var pct = Math.round(100 * (window.scrollY || h.scrollTop) / max);
    marks.forEach(function (d) { if (pct >= d - 2 && !hit[d]) { hit[d] = 1; cap('Scroll Depth', { depth: d, page_type: ctx.page_type, sekundy: Math.round((Date.now() - t0) / 1000) }); } });
    if (A && !readSent && hit[75] && Date.now() - t0 > 30000) { readSent = true; cap('Article Read', { blog: A.blog, handle: A.handle, sekundy: Math.round((Date.now() - t0) / 1000) }); }
  }
  var st; window.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(onScroll, 250); }, { passive: true });

  /* ---- Klaviyo (popup/newsletter, bez adresu e-mail) i Tidio ---- */
  window.addEventListener('klaviyoForms', function (e) {
    var d = e.detail || {}, map = { open: 'Popup Shown', embedOpen: 'Popup Shown', close: 'Popup Closed', submit: 'Newsletter Subscribed', stepSubmit: 'Popup Step Submitted' };
    if (map[d.type]) cap(map[d.type], { form_id: d.formId, miejsce: d.type === 'embedOpen' ? 'klaviyo_embed' : 'klaviyo_popup', page_type: ctx.page_type });
  });
  function tidio() { try { window.tidioChatApi.on('open', function () { cap('Chat Opened', { miejsce: 'tidio', page_type: ctx.page_type }); }); } catch (e) {} }
  if (window.tidioChatApi) tidio(); else document.addEventListener('tidioChat-ready', tidio);

}
})();
